module.exports = __webpack_public_path__ + "static/media/user.6a87cedf.svg";